import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { HistoricList } from 'components/organisms/Historic/HistoricList';
import { HistoricProvider } from 'context/HistoricContext';

import { Grid } from '@mui/material';

import { HistoricSearchBar } from './HistoricSearchBar';

const Component = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mb={1}>
        <BreadcrumbsHeader items={[{ title: 'Meu Histórico' }]} />
      </Grid>
      <Grid item xs={12} mb={2}>
        <HistoricSearchBar />
      </Grid>

      <Grid item xs={12}>
        <HistoricList />
      </Grid>
    </Grid>
  );
};

export const Historic = () => {
  return (
    <HistoricProvider>
      <Component />
    </HistoricProvider>
  );
};

